import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestUpdates() {
  const latestMovies = movies.filter((m) => m.isNew);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">每日更新，精彩不断</p>
          </div>
          <Link
            to="/category/tv"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex gap-4 p-3 md:p-4 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 hover:bg-primary-50/30 transition-all"
            >
              <div className="w-24 md:w-28 flex-shrink-0 rounded-md overflow-hidden aspect-[2/3]">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-medium rounded">
                      {movie.category === 'movie' ? '电影' : movie.category === 'tv' ? '电视剧' : movie.category === 'variety' ? '综艺' : '动漫'}
                    </span>
                    <span className="text-[10px] text-foreground-500">{movie.subCategory}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
                    {movie.description}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {movie.rating}
                  </span>
                  <span>{movie.year}</span>
                  <span className="hidden sm:inline">{movie.director}</span>
                  <span className="ml-auto text-primary-500 text-[11px] whitespace-nowrap">更新</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/tv"
            className="flex items-center gap-1 px-5 py-2.5 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}